<template>
  <equityFund />
</template>

<script>
import equityFund from "./components/equityFunds.vue";

export default {
  name: "App",
  components: {
    equityFund,
  },
};
</script>

<style>
#app {
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}
</style>
